@if (viewMode === 'select') {
    <div #trigger class="ui-user-select-container ui-secondary" [ngClass] = "{'ui-user-selected': selectedUser, 'ui-user-selected-view': readonly}" (click)= "eventOpenOptions()">
        @if (selectedUser) {
            <div class = "ui-select-icon">
                <i class = "{{ icon }}"></i>
            </div>
            <div class = "ui-detail-container">
                <span class="ui-title">{{ selectedUser.name }}</span>
                <span class="ui-sub-title">
                    {{ selectedUser.detail.document.number | mask: selectedUser.detail.document.number.length ? '000.000.000-00' : '99.999.999/9999-99'}}
                </span>
                <span class="ui-label">{{ label }}</span>
                @if (!readonly) {
                    <button class = "ui-button">
                        <span class = "ui-button-label">alterar</span>
                    </button>
                }
            </div>
        } @else if (!readonly) {
            <div class = "ui-detail-container">
                <span class="ui-title">Selecione o {{ label }}</span>
            </div>
        } @else if (readonly) {
            <div class = "ui-select-icon">
                <i class = "{{ icon }}"></i>
            </div>
            <div class = "ui-detail-container">
                <span class="ui-title">{{ label }}</span>
                <span class="ui-sub-title">Não vinculado</span>
            </div>
        }
    </div>

    <ng-template #dropdownTemplate>
        <div class = "ui-select-menu">
            <div class = "ui-field ui-secondary ui-field-without-border">
                <i class = "ui-icon uii-search"></i>
                <input type="text" class="ui-select-menu-search-input" placeholder="Buscar usuário..." (input)="eventUserFilterChange($event)"/>
            </div>

            <div class = "ui-select-options" [ngClass] = "{ 'ui-select-searching-options': searching }">
                @for (user of users; track user._id) {
                    <div class="ui-select-option" (click)="eventUserChanged(user)">
                        <div class = "ui-title">
                            {{ user.name }}
                        </div>
                        <span class = "ui-sub-title">
                            {{ user.detail.document.number | mask: user.detail.document.number.length ? '000.000.000-00' : '99.999.999/9999-99'}}
                        </span>
                    </div>
                }
                @if (users.length === 0) {
                    <div class = "ui-empty-container">
                        Nenhum usuário encontrado
                    </div>
                }
            </div>
        </div>
    </ng-template>
} @else {
    <div class = "ui-user-select-badge-container">
        <div class = "ui-field">
            <i class = "ui-icon uii-search"></i>
            <input type = "text" placeholder = "Pesquisar..." (input)="eventUserFilterChange($event)">
        </div>
        <div class = "ui-users-container">
            @if (!searching) {
                @for (user of users.slice(0, 4); track user._id) {
                    <div class = "ui-badge" (click)="eventUserChanged(user)" [ngClass] = "{'ui-badge-active': selectedUser?._id === user._id}">{{ user.name }}</div>
                }
            } @else {
                <div class = "ui-badge" skeletonLoaderPipe = "rect">
                    Bucando
                </div>
                <div class = "ui-badge" skeletonLoaderPipe = "rect">
                    Bucando
                </div>
            }
        </div>
    </div>
}
